module.exports = "https://www.gc-pro.gnp.com.mx/00ff6aa4da43d21848c1df3f16fd26ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/registro/4.png
// module id = 1053
// module chunks = 0 1